<template>
  <div class="letter" id="letter">
    <!-- <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" /> -->
   
    <!-- <div class="letter-bg" id="letterbg">
      <img src="../static/letterbg.png" class="bg" alt="">
      <img src="../static/letter-box.png" class="box" alt="">
      <img src="../static/letter-words.png" class="words" alt=""> -->
    <!-- <div class="icon-box">
        <img src="../static/letter_icon1.png" class="icon1" @click="tohyl" alt="">
        <img src="../static/letter_icon2.png" class="icon1" alt="" @click="showgry = true">
        <img src="../static/letter_icon3.png" class="icon1" alt="" @click="tofyt">
        <img src="../static/letter_icon4.png" class="icon1" @click="tomap_1" alt="">
        <a href="https://www.720yun.com/vr/4b3jtpuakv0" target="_blank"> <img src="../static/letter_icon5.png"
            class="icon1" alt=""></a>
      </div> -->

    <!-- <img src="../static/letter-but.png" class="but" @click="tomap_1" v-show="but" alt="">
    </div> -->
    <div class="mp4-box">
      <video class="mp4" id="mp4" webkit-playsinline="false" x-webkit-airplay="false" playsinline="false"
        x5-video-player-type="h5" preload="Metadata" @click="ifplay" poster="../static/start_bg.png" :loop="false">
        <source src="../static/start_mp4.mp4" type="video/mp4" />
      </video>
          <P class="theAI">AI辅助生成</P>
      <img src="@/static/skip.png" @click="skip" v-show="theskip" class="skip" alt="" />
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      but: false,
      music: true,
      theskip: true,
    }
  },
  methods: {
        ifplay() {
      const mp4 = document.getElementById("mp4");
      if (mp4.paused && mp4.currentTime != mp4.duration) {
        mp4.play();
  
        this.theskip = true
      }
      else {
        mp4.pause();
 
      }
    },
      skip() {
      console.log("skip",);
      const mp4 = document.getElementById("mp4");
      mp4.play();
      if (mp4.currentTime != mp4.duration) {
        mp4.currentTime = mp4.duration - 0.1;
      }

      //      mp4.play()
    },
    // stopmusic() {
    //   let audio = document.getElementById("audio");
    //   if (this.music == true) {
    //     this.music = false;
    //     audio.pause();

    //   } else {
    //     this.music = true;
    //     // audio.volume = 0.2;
    //     audio.play();
    //   }
    // },

    tomap_1() {
      // let audio = document.getElementById("audio");
      // window.sessionStorage.setItem("time", audio.currentTime);
      // window.sessionStorage.setItem("music", this.music);
      this.$router.push("map")

    },

  },
  mounted() {
    const mp4 = document.getElementById("mp4");
  
    mp4.play()
    var that = this
    mp4.addEventListener(
      "ended",
      function () {
        //结束
     
        that.tomap_1()
        console.log("播放结束");


      },
      false
    );
  },
}
</script>

<style lang="less">
.letter {
  width: 100%;
  height: 100vh;

  .mp4-box {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 50;


    .mp4 {
      //   height: 100vh;
      object-fit: fill;
      width: 100%;
      height: 100vh;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }

    .theAI{
      position: absolute;
      width:100px ;
      font-size: 16px;
      color: aliceblue;
      bottom: 20px;
      left: 20px;

    }

    .skip {
      position: absolute;
      width: 70px;
      top: 30px;
      left: 20px;
      z-index: 66;
    }
  }

  .music {
    position: fixed;
    top: 15px;
    right: 15px;
    width: 40px;
    z-index: 3;
    transform: rotate(250deg);

    &.zhuan {
      animation: turn 2s linear infinite;

      @keyframes turn {
        0% {
          -webkit-transform: rotate(0deg);
        }

        25% {
          -webkit-transform: rotate(90deg);
        }

        50% {
          -webkit-transform: rotate(180deg);
        }

        75% {
          -webkit-transform: rotate(270deg);
        }

        100% {
          -webkit-transform: rotate(360deg);
        }
      }
    }
  }

  .letter-bg {
    position: relative;


    .bg {
      width: 100%;
      position: relative;
      display: block;
    }

    .box {
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
    }

    .words {
      position: absolute;
      bottom: 160px;
      width: 290px;
      left: 50%;
      margin-left: -144px;

    }

    .icon-box {
      position: absolute;
      width: 70px;
      right: 30px;
      height: 530px;
      bottom: 230px;

      .icon1 {
        width: 100%;
        margin-bottom: 20px;

      }
    }

    .but {
      position: absolute;
      bottom: 50px;
      width: 180px;
      left: 50%;
      margin-left: -90px;
      animation: an-thebut 1.5s linear infinite;

      @keyframes an-thebut {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.1);
        }

        100% {
          transform: scale(1);
        }
      }

    }
  }


}
</style>
